import { render } from "./HelloWorld.vue?vue&type=template&id=4c66b446"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murat\\OneDrive\\mkss\\source\\vuejs\\practiceone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__